<template>
  <div class="container">
    <div class="index" v-if="!detail.show">
      <div class="title">
        <span>{{$route.name}}</span>
      </div>
      <div class="query">
        <div class="query">
          <el-form ref="form" :inline="true" :model="form">
		    <el-form-item label="学期学年">
             <el-select v-model="form.value1" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in list1" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
             </el-select>
            </el-form-item> 
			 <el-form-item label="授课老师">
             <el-select v-model="form.value2" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in list2" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
             </el-select>
            </el-form-item> 
			<el-form-item label="投诉课程">
             <el-select v-model="form.value3" clearable placeholder="请选择" class="label">
                        <el-option v-for="item in list3" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
             </el-select>
            </el-form-item>
			<el-form-item label="投诉日期">
                <el-date-picker 
					v-model="form.selectData"
					type="daterange"
					style="width: 240px;"
					range-separator="-"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="pickerOptions">
					</el-date-picker>
            </el-form-item> 
            <el-form-item label="">
              <el-button type="primary" size="small" @click="searchFun"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column
            align="center"
            prop="w"
            label="投诉编号"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="e"
            label="投诉时间"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="r"
            label="投诉课程"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
            align="center"
            prop="t"
            label="授课教师"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="y"
            label="投诉人"
            show-overflow-tooltip
          >
          </el-table-column> -->
		    <el-table-column
            align="center"
            prop="u"
            label="投诉详情"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <!-- <Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail> -->
  </div>
</template>

<script>
import dayjs from "dayjs";
import api from "@/api/wisdomSchool/index";
// import store from '@/store';
export default {
  //   components: {
  //     Detail: () => import("./details.vue"),
  //   },
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        endDate: "",
        selectData: "",
      },
	  selectList: [],
      semesterList: [],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 9,
      },

      info: "", // 出库单页面参数
     	tableData: [
		//  {w:'78878811',e:'2021/11/23 17:56:2',r:'智慧机器人',t:'60',y:'33600', u:'查看详情'},
		//  {w:'65178257',e:'2021/11/24 20:34:3',r:'幸福劳动',t:'60',  y:'27600', u:'查看详情'},
		//  {w:'55898935',e:'2021/11/29 22:19:4',r:'智慧机器人',t:'63',y:'25200', u:'查看详情'},
		//  {w:'87691486',e:'2021/11/8 5:26:14', r:'优美声乐',t:'7',   y:'24000' ,u:'查看详情'},
		//  {w:'49069063',e:'2021/11/2 12:55:18',r:'智慧机器人',t:'6', y:'27600' ,u:'查看详情'},
		//  {w:'53742317',e:'2021/11/17 5:14:41',r:'智慧机器人',t:'6', y:'24000' ,u:'查看详情'},
		//  {w:'55652016',e:'2021/11/28 2:07:39',r:'幸福劳动',t:'5',   y:'27600' ,u:'查看详情'},
		//  {w:'74476108',e:'2021/11/21 0:29:26',r:'博学书法',t:'6',   y:'31200' ,u:'查看详情'},
		//  {w:'81448407',e:'2021/11/17 7:51:47',r:'作业辅导',t:'6',   y:'24000' ,u:'查看详情'},
		 ],
		 	 list1:[
				{id:"1",label:"2021~2022年度下学期	  ",  value:"1"},
				{id:"2",label:"2021~2022年度上学期	 ",value:"2"},
				{id:"3",label:"2020~2021年度下学期	 ",  value:"3"},
				{id:"4",label:"2020~2021年度上学期	 ",value:"4"},
				{id:"5",label:"2019~2020年度下学期	 ",  value:"5"},
				{id:"6",label:"2019~2020年度上学期	  ",value:"6"},
			],
			list2:[
				{id:"1",label:"庄萍雅 ",  value:"1"},
				{id:"2",label:"杨萍蓓 ",value:"2"},
				{id:"3",label:"严姣婷 " ,  value:"3"},
				{id:"4",label:"昌琦嘉 ",value:"4"},
				{id:"5",label:"奚秋叶 ",  value:"5"},
				{id:"6",label:"强希礼 ",value:"6"},
				{id:"3",label:"明环凯 ",  value:"3"},
				{id:"4",label:"闫媛娣 ",value:"4"},
				{id:"5",label:"习华伊 ",  value:"5"},
				{id:"6",label:"寿歌姣 ",value:"6"},
			],
			list3:[
				{id:"1",label:"科技编程	  ",  value:"1"},
				{id:"2",label:"酷酷机器人 ",value:"2"},
				{id:"3",label:"幸福劳动 ",  value:"3"},
				{id:"4",label:"博学书法 ",value:"4"},
				{id:"5",label:"美学鉴赏课 ",  value:"5"},
				{id:"6",label:"温暖美术  ",value:"6"},
				{id:"3",label:"世界百科课 ",  value:"3"},
				{id:"4",label:"海滨少儿美术 ",value:"4"},
				{id:"5",label:"竞技篮球 ",  value:"5"},
				{id:"6",label:"优美声乐  ",value:"6"},
			],
      currentPage: 4,
      detail: {
        info: {},
        show: false,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
	  pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
	  },
    };
  },
  mounted() {},
  created() {
    if (this.semesterArr.length > 0) {
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
        value: v.schoolYear + "_" + v.semester,
        id: v.id,
      }));
    }
    console.log("获取学年学期数据--", this.semesterList);
    // this.getDataList();
  },
  methods: {
    async getDataList() {
      if (this.form.selectData == "" || this.form.selectData == null) {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      let params = {
        schoolYearSemester: this.form.schoolYearSemester,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        teacherId: "", 
        courseName: this.form.courseName,
        extOrgName: this.form.extOrgName,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      var { data, code } = await api.teacherCourseAttendance(params);
      console.log("获取考勤列表数据---", data);
      if (code == "0") {
        this.tableData = data.list;
        this.page.totalPage = data.total;
      }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },
    toDetail(scope) {
    //   console.log(scope);
    //   this.detail.info = scope.row;
    //   this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  /* width: 140px; */
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
</style>
